/** FAQ home: mismo texto en pantalla y en JSON-LD FAQPage */
export const HOME_SEO_FAQ = [
  {
    question: '¿Necesito un ERP a medida?',
    answer:
      'No siempre. A veces el valor está en integrar lo que tienes, automatizar pasos sueltos o configurar bien un ERP modular. Lo revisamos con datos reales, no con una checklist genérica.',
  },
  {
    question: '¿Vulpin sirve para pymes?',
    answer:
      'Sí. El área Business de Vulpin 360 está pensada para pymes. Si tu caso encaja, lo implantamos con el mismo criterio que cualquier otro proyecto: menos humo, más uso diario.',
  },
  {
    question: '¿Trabajan con ONG?',
    answer:
      'Sí, con software de gestión, expedientes y proyectos sociales, y con el área Social de Vulpin cuando encaja. Más detalle en e-asy.es/erp-para-ong.',
  },
  {
    question: '¿Se puede integrar con otras herramientas?',
    answer:
      'En muchos casos sí, vía API o conectores. Te decimos qué es sólido, qué es frágil y qué no merece el esfuerzo.',
  },
  {
    question: '¿Podéis desplegar nuestra aplicación o agente de IA?',
    answer:
      'Sí. Si ya tenéis un prototipo (ChatGPT, Cursor, freelance o no-code) y no arranca en el día a día, lo llevamos a producción: backend, API y Azure. Detalle en e-asy.es/servicios/ia-en-produccion.',
  },
  {
    question: '¿Implantáis Business Central y Azure?',
    answer:
      'Sí. Azure para la infraestructura de los proyectos (e-asy.es/servicios/azure) y Dynamics 365 Business Central cuando el ERP Microsoft encaja (e-asy.es/servicios/business-central). Si el caso es sociosanitario, partimos de Vulpin.',
  },
  {
    question: '¿Cómo es el proceso de implantación?',
    answer:
      'Diagnóstico breve, propuesta por fases, entregas que puedas usar, formación y seguimiento. Sin sorpresas de alcance a mitad de proyecto.',
  },
];
